// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ozycTJ {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.OANylk {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.mS8Mws {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.uiCbw3 {
  padding: var(--spacing-3) var(--spacing-2) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.iIgDfu {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.iIgDfu img {
  width: 100%;
  height: 100%;
}

.S0z4DP {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
}

.d3Kmx5 {
  padding: var(--spacing-3) 0 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.ISDsix,
.VVMswf {
  padding: 0 var(--spacing-3);
}

.VlUP3o {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  padding: var(--spacing-4);
}

.MSbaSz {
  background: rgba(214, 64, 0, 0.1);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.TRjyoz {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: var(--spacing-3);
}

.KLIfBN {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
  text-align: center;
}

.VVMswf {
  flex: 1;
  overflow-y: auto;
}

.tTNesI {
  padding: 0;
}

@media (max-width: 768px) {
  .OANylk {
    width: 95%;
    margin: 1rem auto;
  }

  .uiCbw3 {
    padding: 0.75rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/CardTrackingPage/components/BeneficiariesModal/BeneficiariesModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-2) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.backButton img {\n  width: 100%;\n  height: 100%;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n}\n\n.modalBody {\n  padding: var(--spacing-3) 0 0 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.filtersContainer,\n.contentContainer {\n  padding: 0 var(--spacing-3);\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n  padding: var(--spacing-4);\n}\n\n.feedbackIconContent {\n  background: rgba(214, 64, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: var(--spacing-3);\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.contentContainer {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.beneficiariesList {\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .modalDialog {\n    width: 95%;\n    margin: 1rem auto;\n  }\n\n  .modalHeader {\n    padding: 0.75rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ozycTJ`,
	"modalDialog": `OANylk`,
	"modalContent": `mS8Mws`,
	"modalHeader": `uiCbw3`,
	"backButton": `iIgDfu`,
	"modalTitle": `S0z4DP`,
	"modalBody": `d3Kmx5`,
	"filtersContainer": `ISDsix`,
	"contentContainer": `VVMswf`,
	"feedbackContainer": `VlUP3o`,
	"feedbackIconContent": `MSbaSz`,
	"feedbackTitle": `TRjyoz`,
	"feedbackText": `KLIfBN`,
	"beneficiariesList": `tTNesI`
};
module.exports = ___CSS_LOADER_EXPORT___;
